export default __webpack_public_path__ + "static/media/w7.6dae7f76.jpg";